(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./error.less", "../popup", "../empty", "../_util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./error.less"), require("../popup"), require("../empty"), require("../_util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.error, global.popup, global.empty, global._util);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _error, _popup, _empty, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _popup = _interopRequireDefault(_popup);
  _empty = _interopRequireDefault(_empty);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-error"
      }, [_c('nx-popup', {
        attrs: {
          "value": _vm.value,
          "hasMask": false,
          "lockScroll": true,
          "preventScroll": true
        },
        on: {
          "input": _vm.$_onInput,
          "show": _vm.$_onShow,
          "hide": _vm.$_onHide
        }
      }, [_c('nx-empty', {
        attrs: {
          "type": _vm.type,
          "description": _vm.description
        },
        on: {
          "retry": _vm.refresh
        }
      })], 1)], 1);
    },
    name: 'nx-error',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _popup.default.name, _popup.default), (0, _defineProperty2.default)(_components, _empty.default.name, _empty.default), _components),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'error'
      },
      description: {
        type: String
      },
      appendTo: {
        default: function _default() {
          return _util.mdDocument.body;
        }
      },
      buttonText: {
        type: String,
        default: ''
      }
    },
    mounted: function mounted() {
      if (this.appendTo) {
        this.appendTo.appendChild(this.$el);
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.appendTo && this.appendTo.contains(this.$el)) {
        this.appendTo.removeChild(this.$el);
      }

      document.querySelector('body').classList.remove('nx-dialog-lock-scroll');
    },
    methods: {
      refresh: function refresh() {
        this.$emit('click');
      },
      $_onInput: function $_onInput(val) {
        this.$emit('input', val);
      },
      $_onShow: function $_onShow() {
        this.$emit('show');
      },
      $_onHide: function $_onHide() {
        this.$emit('hide');
      },
      close: function close() {
        this.$emit('input', false);
      }
    }
  };
  _exports.default = _default2;
});